jQuery(document).ready(function($) {
    const $podcast = $('.js-podcast');
    const $control = $('.js-audio-player-control');
    const $playFirst = $('.js-play-first');

    function getMediaElement() {
        return $control.find('audio').get(0);
    }

    $podcast.on('click', function(event) {

        $control.addClass('active');
        const $item = $(this);
        const $icon = $item.find('.thumbnail-play-icon');
        const audioUrl = $item.data('audio');
        const mediaElement = getMediaElement();
        const isPlaying = $item.hasClass('is-playing');

        event.preventDefault();

        if (!audioUrl || !mediaElement) {
            return;
        }

        if (isPlaying) {
            mediaElement.pause();
            $item.removeClass('is-playing');
            $icon.removeClass('is-pause');
            $control.removeClass('active');
            return;
        }

        console.log('clic play event');
        _paq.push(['trackEvent', 'Podcast', 'Clic', 'Lecture']);

        $item.addClass('is-playing').siblings().removeClass('is-playing');
        $icon.addClass('is-pause');
        $item.siblings().find('.thumbnail-play-icon').removeClass('is-pause');

        if (mediaElement.src !== audioUrl) {
            mediaElement.src = audioUrl;
            mediaElement.load();
        }

        mediaElement.play();
    });

    $playFirst.on('click', function(event) {
        event.preventDefault();

        const $firstPodcast = $podcast.first();

        if (!$firstPodcast.length) {
            return;
        }

        $firstPodcast.trigger('click');
    });
});